import React, {Component} from 'react';

export default class Text extends Component {

    constructor(props) {
        super(props);

        this.state = {
            label: '',
        };
    }

    onFocus = () => {
        this.setState({
            label: 'active',
        });
    };

    onBlur = (event) => {
        const {
            name,
        } = this.props.params;

        const value = event.target.value;

        if (value) {
            this.props.setField(
                name,
                value,
                '',
            );

            return;
        }

        this.setState({
            label: 'inactive',
        });

        if (
            this.props.state.fields[name].role.required
        ) {
            this.props.setField(
                name,
                value,
                'Kötelező megadni',
            );
        }
    };

    onChange = (event) => {
        const value = event.target.value;

        if (
            value.indexOf('<') < 0
            && value.indexOf('>') < 0
        ) {
            this.props.setField(
                this.props.params.name,
                value,
            );
        }
    };

    render() {
        const {
            params,
            state,
        } = this.props;

        const field = state.fields[params.name];

        const error = field.error
            ? (
                <span className="error">
                    <i className="fa fa-warning" />
                    {' '}
                    {field.error}
                </span>
            )
            : null;

        const label = field.value
            ? 'active'
            : this.state.label;

        const hasError = field.error
            ? 'has-error'
            : '';

        return (
            <div
                className={
                    `field field-text ${params.id} ${hasError}`
                }
                style={params.style}
            >
                <div>
                    <label
                        htmlFor={params.id}
                        className={params.classLabel}
                    >
                        {params.label}
                    </label>

                    <input
                        type="text"
                        spellCheck="false"
                        autoComplete="off"
                        readOnly={params.readonly}
                        id={params.id}
                        className={params.classInput}
                        name={params.name}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onChange={this.onChange}
                        value={field.value || ''}
                        placeholder={params.placeholder}
                        disabled={params.disabled}
                    />

                    <p className="help-block help-block-error">
                        {error}
                    </p>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/fields/Text.js